import { render, staticRenderFns } from "./GameBoardChicago.vue?vue&type=template&id=7c399d7e"
import script from "./GameBoardChicago.vue?vue&type=script&lang=js"
export * from "./GameBoardChicago.vue?vue&type=script&lang=js"
import style0 from "./GameBoardChicago.vue?vue&type=style&index=0&id=7c399d7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports